import { Button } from '@massilia/ui'
import { AlertTriangle } from 'lucide-react'

interface SessionExpiredErrorProps {
  actionLabel?: string
  message?: string
  onAction: () => void
}

export function SessionExpiredError({
  actionLabel = 'Relancer la recherche',
  message = 'Session expirée. Veuillez relancer votre recherche.',
  onAction,
}: SessionExpiredErrorProps) {
  return (
    <div className="flex flex-col items-center gap-6 py-8">
      <div className="rounded-full bg-orange-100 p-4">
        <AlertTriangle className="size-8 text-orange-600" />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-light-900">Session expirée</h3>
        <p className="mt-2 max-w-md text-sm text-gray-light-600">{message}</p>
      </div>
      <Button className="bg-brand-600 hover:bg-brand-700" onClick={onAction}>
        {actionLabel}
      </Button>
    </div>
  )
}
